import sortBy from 'lodash/sortBy';

import { SectionOrSubSection } from 'approot/activity-builder/activity-builder.constants';
import {
  ACTIVITIES_COMPONENT_TYPE_ACTIVITY,
  ACTIVITIES_COMPONENT_TYPE_COLUMNS,
  LANGUAGE_CODE_EN_AU,
  LanguageCodes,
} from 'global/constants';
import { ComponentColumns } from 'approot/activity-builder/components/component.constants';
import { ComponentViewWrapper } from 'approot/activity-builder/components/components-view-wrapper.style';
import ActivityAnswersPrintComponent from './activity-answers-print-component';
import ActivityAnswersPrintColumns from './activity-answers-print-columns';
import { getStyleProperties } from 'approot/activity-builder/components/components.utils';
import {
  getAppliedColour,
  isBackgroundApplied,
  isBorderApplied,
} from 'approot/activity-builder/components/shared/component-settings-borders.utils';

type Props = {
  previewType: string;
  section: SectionOrSubSection;
  language?: LanguageCodes;
  onRenderComplete?: () => void;
  studentId?: number;
  contentVersion: string | null | undefined;
};

const ActivityAnswersPrintComponents = ({
  previewType,
  section,
  language,
  onRenderComplete,
  studentId,
  contentVersion,
}: Props) => {
  const components = section?.components;
  const sortedComponents = sortBy(components, 'sort');

  return (
    <>
      {sortedComponents.map(component => {
        return component.type !== ACTIVITIES_COMPONENT_TYPE_ACTIVITY ? (
          <ComponentViewWrapper
            key={component.id}
            $colours={getAppliedColour(getStyleProperties(component))}
            $showBorder={isBorderApplied(getStyleProperties(component))}
            $showBackground={isBackgroundApplied(getStyleProperties(component))}
          >
            {component.type === ACTIVITIES_COMPONENT_TYPE_COLUMNS ? (
              <ActivityAnswersPrintColumns
                previewType={previewType}
                {...(component as ComponentColumns)}
                studentId={studentId}
                language={language || LANGUAGE_CODE_EN_AU}
                onRenderComplete={onRenderComplete}
                contentVersion={contentVersion}
              />
            ) : (
              <ActivityAnswersPrintComponent
                previewType={previewType}
                component={component}
                studentId={studentId}
                language={language}
                onRenderComplete={onRenderComplete}
                contentVersion={contentVersion}
              />
            )}
          </ComponentViewWrapper>
        ) : null;
      })}
    </>
  );
};

export default ActivityAnswersPrintComponents;
